import {exeRequest} from '../utils/APIUtils'

export default {
    //get : async  (dates, concessionnaireId) => exeRequest(`/commissions?dateDebut=${dates.debut}&dateFin=${dates.fin}&concessionnaireId=${concessionnaireId}`, "GET")
     get : async  (dates, concessionnaireId) => exeRequest(`/commissions?dateDebut=${dates.debut}&dateFin=${dates.fin}&concessionnaireId=${concessionnaireId}`, "GET")
}